import { Component, Inject, Input, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  textExtra:string
}

@Component({
  selector: 'app-model-modal-locale',
  templateUrl: './model-modal-locale.component.html',
  styleUrls: ['./model-modal-locale.component.scss']
})
export class ModelModalLocaleComponent implements OnInit {

  help!: string;
  whatsAppSac: string | undefined;

  constructor(public dialogRef: MatDialogRef<ModelModalLocaleComponent>,  @Inject(MAT_DIALOG_DATA) public data: DialogData,) { 

    this.getHelp()
    
  }

  ngOnInit(): void {
    this.whatsAppSac = environment.contacts.whatsAppSac
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getHelp(){


    if(navigator.userAgent.indexOf("Edg") != -1 )
    {
      this.help = 'https://support.microsoft.com/pt-br/microsoft-edge/localiza%C3%A7%C3%A3o-e-privacidade-no-microsoft-edge-31b5d154-0b1b-90ef-e389-7c7d4ffe7b04'
    }
    else if(navigator.userAgent.indexOf("Chrome") != -1 )
    {
      this.help = 'https://support.google.com/chrome/answer/142065?hl=pt-BR&co=GENIE.Platform%3DAndroid'
    }
    else if(navigator.userAgent.indexOf("Safari") != -1)
    {
      this.help = 'https://support.apple.com/pt-br/HT5403'
    }
    else if(navigator.userAgent.indexOf("Firefox") != -1 ) 
    {
      this.help = 'https://support.mozilla.org/pt-BR/kb/o-firefox-compartilha-minha-localizacao-com-sites#:~:text=Use%20o%20campo%20de%20pesquisa,di%C3%A1logo%20Configura%C3%A7%C3%B5es%20%2D%20Permiss%C3%B5es%20de%20Localiza%C3%A7%C3%A3o.'
    }
   

  }

}